import { apiSlice } from "app/api/apiSlice"

export const deviceDiagnosticsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDevicesDiagnosticsResume: builder.query({
            query: () => ({
                url: 'devices/diagnostics',
                method: 'GET'
            }),
            providesTags: ['deviceDiagnostics']
        }),
        getDeviceLogs: builder.query({
            query: ({ deviceGuid, page = 0, pageSize = 20 }) => ({
                url: 'devices/log',
                method: 'GET',
                params: { deviceGuid, pageNumber: page, pageSize }
            }),
            providesTags: ['deviceLogs']
        }),
        clearDeviceLogs: builder.mutation({
            query: (deviceGuid) => ({
                url: 'devices/log',
                method: 'DELETE',
                params: { deviceGuid }
            }),
            invalidatesTags: ['deviceDiagnostics', 'deviceLogs']
        }),
        clearAllDeviceLogs: builder.mutation({
            query: () => ({
                url: 'devices/log/all',
                method: 'DELETE'
            }),
            invalidatesTags: ['deviceDiagnostics', 'deviceLogs']
        })
    })
})

export const {
    useGetDevicesDiagnosticsResumeQuery,
    useLazyGetDevicesDiagnosticsResumeQuery,
    useGetDeviceLogsQuery,
    useLazyGetDeviceLogsQuery,
    useClearDeviceLogsMutation,
    useClearAllDeviceLogsMutation
} = deviceDiagnosticsApiSlice
